import { render, staticRenderFns } from "./SliderInput.vue?vue&type=template&id=643a2245&scoped=true&"
import script from "./SliderInput.vue?vue&type=script&lang=js&"
export * from "./SliderInput.vue?vue&type=script&lang=js&"
import style0 from "./SliderInput.vue?vue&type=style&index=0&id=643a2245&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a2245",
  null
  
)

/* custom blocks */
import block0 from "./SliderInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643a2245')) {
      api.createRecord('643a2245', component.options)
    } else {
      api.reload('643a2245', component.options)
    }
    module.hot.accept("./SliderInput.vue?vue&type=template&id=643a2245&scoped=true&", function () {
      api.rerender('643a2245', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/form-input/SliderInput.vue"
export default component.exports